export default __webpack_public_path__ + "static/media/anti-virus-1.d0599b67.png";